module.exports = __webpack_public_path__ + "media/applications/components/ItemApp/assets/images/arrow-12465c101baa2d0739c605b4a0d41d59.svg";